import { Transition } from '@headlessui/react';

export function FadeInOut({ children, show = true, ...props }) {
  return (
    <Transition
      {...props}
      show={show}
      enter="transition-opacity duration-150"
      enterFrom="opacity-0"
      enterTo="opacity-100"
      leave="transition-opacity duration-0"
      leaveFrom="opacity-100"
      leaveTo="opacity-0"
    >
      {children}
    </Transition>
  );
}
